module.exports = __webpack_public_path__ + "static/media/prod9-bg.da2b8dce.png";